





























import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import AMSImg from './AMSImg.vue';
import AMSTooltip from '@/components/AMSTooltip.vue';
import utils from '@/utils/utils';
@Component({
  components: {
    'ams-img': AMSImg,
    'ams-tooltip': AMSTooltip,
  },
})
export default class AMSProductImg extends Vue {
  @Prop({
    default: () => {
      return {};
    },
  })
  product!: object;
  @Prop({ default: false }) isShowNumber!: boolean;
  @Prop({ default: false }) isShowPrice!: boolean;
  @Prop() pictureWidth?: number;
  @Prop() pictureHeight?: number;
  @Prop({ default: '' }) color!: string;
  @Prop({ default: false }) showMark!: boolean;//隐藏商品标识
  formatPrice(num: number) {
    return utils.formatCurrencyPrice(num);
  }
  goToDetails(id: string) {
    this.$router.push({
      name: `productManage_details`,
      query: {
        id: id,
      },
    });
  }
}
